<template>
	<div>
		<div class="left_top_name" :style="user.company_id == 'esha' ? 'background-color:#F562B7;' : ''">
			<h1 ref="company_name">
				<router-link to="/"
					>{{ company_name
					}}<template v-if="env != 'production'"
						>&nbsp;<font color="white">({{ env == 'test' ? 'Test' : env == 'development' ? 'Dev' : '' }})</font>
					</template></router-link
				>
			</h1>
			<a href="javascript:void(0);" v-on:click="clickEvent" class="aside_bt">menu open/close</a>
		</div>

		<div class="left_userbox" :style="user.company_id == 'esha' ? 'background-color:#F562B7;' : ''">
			<p>
				{{ user_name }}
				<a href="javascript:;" v-on:click="logout">Logout</a>
			</p>
		</div>
	</div>
</template>

<script>
import { apiLogout } from '@/api/auth';

export default {
	data: function() {
		return {
			user_name: '',
			company_name: '',
		};
	},
	computed: {
		env: function() {
			return process.env.NODE_ENV;
		},
		user: function() {
			return this.$session.get('user');
		},
	},
	methods: {
		async logout() {
			await apiLogout();
			this.$session.destroy();
			//console.log(response);
			//this.$store.commit('delToken');
			//this.$router.push('/login');
			window.location = '/login';
		},
		clickEvent() {
			const localStorage = window.localStorage;
			let sideValue = this.getSideValue();
			if (sideValue) {
				this.sideOff();
				localStorage.setItem('sideValue', 'false');
			} else {
				this.sideOn();
				localStorage.setItem('sideValue', 'true');
			}
		},
		getSideValue() {
			let value = localStorage.getItem('sideValue');
			return value === null ? true : value !== 'false';
		},
		sideOff() {
			document.body.classList.add('false');
		},
		sideOn() {
			document.body.classList.remove('false');
		},
	},
	created() {
		const user = this.$session.get('user');
		this.user_name = user.name;
		this.company_name = user.company_name;
	},
	mounted() {
		if (this.getSideValue()) {
			this.sideOn();
		} else {
			this.sideOff();
		}
	},
};
</script>

<style scoped></style>
